import { constants } from "./company-defaults";

export function handleTeamName(name: string, role: string) {
  const result = constants.profiles.find(obj => obj.key === role);

  return result ? `${name} (${result.name})` : null;
}

export function handleTeamFunction(role: string) {
  const result = constants.profiles.find(obj => obj.key === role);

  return result ? result.name : null;
}
export const renderTier = (tier: boolean) => {
  return tier ? 'SIM' : 'NÃO'
}
export const renderTierBadge = (level: string) => {
  if (level === 'SIM') {
    return '⭐'
  }

  if (level === 'NÃO') {
    return '--'
  }
}